import React from 'react'
import { Grommet, grommet as grommetTheme } from 'grommet'
import { deepMerge } from 'grommet/utils'

export const magnitude = deepMerge(grommetTheme, {
  global: {
    font: {
      family: 'Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif',
      size: '14px',
      height: '20px',
    },
    colors: {
      brand: '#6d5cae',
      background: '#FAFAFA',
      focus: '#6d5cae',
      'accent-1': '#3a8fc8',
      'accent-2': 'rgb(52, 60, 102)',
      'status-ok': '#6d5cae',
      'status-critical': '#eb1c23',
      'status-disabled': '#e0e0e0',
      'neutral-3': '#525252',
    },
  },

  anchor: {
    color: '#007bff',
    fontWeight: 400,
  },

  button: {
    border: {
      radius: '4px',
    },
    padding: {
      vertical: '6px',
      horizontal: '12px',
    },
    extend: () => `
      font-weight: 500;
      font-size: 14px;
    `,
  },

  textInput: {
    extend: () => `
      padding: 6px 8px;
    `,
  },

  formField: {
    border: {
      position: 'none',
    },
    label: {
      color: 'dark-3',
      size: 'small',
      margin: 'xxsmall',
      weight: 400,
    },
    disabled: {
      background: {
        color: 'status-disabled',
        opacity: true,
      },
    },
    content: {
      pad: 'xxsmall',
    },
    error: {
      margin: 'xxsmall',
      size: 'xsmall',
    },
    margin: 'none',
  },

  table: {
    header: {
      align: 'center',
    },
    body: {
      align: 'center',
      pad: { vertical: 'small' },
    },
    extend: () => `
      thead {
        font-weight: bold;
      }

      td:nth-child(1) {
        text-align: left;
      }

      tbody > tr:hover {
        background-color: #DAEFFD;
      }

      td > button {
        background: white;
        z-index: 1;
      }

      tr {
        border-bottom: 1px solid #d1d1d1;
      }
    `,
  },
})

const MagnitudeTheme = ({ children }) => (
  <Grommet
    full
    theme={magnitude}
    cssVars
    background="background"
  >
    {children}
  </Grommet>
)

export default MagnitudeTheme
